//API Method Constants

//for sharing portal redirection
export const Method_Activate_Lab_Url = 'session/';
export const Method_Running_Lab_Url = 'session/';
export const Method_New_Lab_Url = 'lab/';
export const Method_Update = 'lab/{LAB_ID}/';
export const Method_Landing = 'landing';
export const INSTRUCTION_URL = 'instruction/'
export const AVAILABLE_SLOTS = 'lab-available-slots/'
export const SCHUDLE_LAB ='lab-scheduler/'
export const SEND_MAIL = "mail-lab/"
export const INVOKE_LAB_CLEANUP = "invoke-lab-cleanup/"
export const INVOKE_LAB_CLEANUP_SETUP = "lab-cleanup-setup/"
export const USER_AGREEMENT = "user-agreement/"
export const AGREEMENT = "agreement/"
export const Feedback_URL ='feedback/'


//Pagination
export const PAGINATION_SIZE_OPTIONS = [8, 12, 24, 50, 200];

//common message
export const LAB_SERVICE_MESSAGE = "This lab runs on real hardware and needs to be scheduled."
export const LAB_ON_DEMAND_MESSAGE = "This lab runs on simulators and does not need to be scheduled. Please note you may have limited functionality."
export const SENDERS_NOTE = "Sender's Note can not be empty."

export const ON_DEMAND_LAB = "ONDEMAND"
export const LAB_AS_A_SERVICE = "LABASASERVICE"
export const PREP_LAB_ONDEMAND ="PREPONDEMAND"